import { http } from "../http";

export const getQueuedReports = async (userId) => {
  try {
    const response = await http.get(`/user/get_queued_reports/${userId}`);
    return response.data.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getOdh_hvPermissionDetails = async (userId) => {
  try {
    const response = await http.get(`/user/is_odh_hv/${userId}`);
    return response.data.is_odh_hv;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getPrt_grantedPermissionDetails = async () => {
  try {
    const response = await http.get(`/admin/check_access_program_reports`);
    return response.data.prt_granted;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};
export const getProgramProfile = async (organizationId) => {
  try {
    const response = await http.get(
      `/api/organization_profile/${organizationId}`
    );
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};
